import { Input, InputProps, useFormControlContext } from '@bonusly/design-system';

export const FormInput = ({ ...rest }: InputProps) => {
	const { isInvalid } = useFormControlContext();
	return <Input backgroundColor={isInvalid ? 'error.inputBg' : 'bg.surface'} {...rest} />;
};
